import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import startCase from 'lodash/startCase'
import type { Option } from 'modules/types'
import { ImportRequestScanResult } from 'services/import-requests/enums'

interface ImportRequestScanResultFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const ImportRequestScanResultFilter = ({ onApply, onReset }: ImportRequestScanResultFilterProps) => {
  const options = Object.values(ImportRequestScanResult).map(scanResult => ({
    label: startCase(scanResult),
    value: scanResult
  }))

  return (
    <CheckboxFilter label="Scan result" options={options} onApply={onApply} onReset={onReset} withFuzzySearch={false} />
  )
}
